import { Cross2Icon } from "@radix-ui/react-icons";
import { Box, DataList, Heading, IconButton, Text } from "@radix-ui/themes";

import { setSelectedCameraSkuSection } from "@/entities/planogram";
import { useAppDispatch } from "@/app/appStore";
import { SelectedSku } from "./selected-sku";

export function SkuSectionInfo({
  selectedCameraSkuSection,
  renderProjections,
}: {
  selectedCameraSkuSection: any;
  renderProjections?: React.ReactNode;
}) {
  const dispatch = useAppDispatch();

  if (!selectedCameraSkuSection) return null;

  return (
    <Box py="2" className="grow relative">
      <Heading size="2" mx="2">
        SKU Section info
      </Heading>

      <IconButton
        variant="ghost"
        color="gray"
        size="1"
        className="m-0 absolute top-1.5 right-2"
        onClick={() => {
          dispatch(setSelectedCameraSkuSection(null));
        }}
      >
        <Cross2Icon />
      </IconButton>
      <Box p="2">
        <DataList.Root size="1" className="gap-1">
          <DataList.Item>
            <DataList.Label>Camera SKU Section ID:</DataList.Label>
            <DataList.Value>{selectedCameraSkuSection.id}</DataList.Value>
          </DataList.Item>
          <DataList.Item>
            <DataList.Label>SKU Section ID:</DataList.Label>
            <DataList.Value>
              {selectedCameraSkuSection.sku_section_id}
            </DataList.Value>
          </DataList.Item>
        </DataList.Root>
        {selectedCameraSkuSection.variant ? (
          <SelectedSku variant={selectedCameraSkuSection.variant} />
        ) : (
          <Text>No SKU selected</Text>
        )}
        {renderProjections}
      </Box>
    </Box>
  );
}
